import { useState } from 'react';

import { useToast } from '../../contexts/ToastContext';
import { toUserErrorMessage } from '../../lib/apiError';
import { downloadFile } from '../../lib/downloadFile';
import { IconDownload } from '../incidents/icons';

const EXPORTS = [
  {
    id: 'late-cancellations',
    title: 'Annulations tardives',
    description: 'Détail de chaque annulation < 2h avec date, course et motif.',
    path: '/v1/extranet/performance/exports/late-cancellations.xlsx',
    filename: 'allocab-extranet-annulations-tardives.xlsx',
  },
  {
    id: 'no-shows',
    title: 'No-show passager',
    description: 'Détail de chaque no-show agent avec date, course et établissement.',
    path: '/v1/extranet/performance/exports/no-shows.xlsx',
    filename: 'allocab-extranet-no-show.xlsx',
  },
  {
    id: 'kpi-report',
    title: 'Rapport KPI complet',
    description: 'Ensemble des indicateurs sur la période avec graphiques.',
    path: '/v1/extranet/performance/exports/kpi-report.xlsx',
    filename: 'allocab-extranet-rapport-kpi.xlsx',
  },
];

export const PerformanceExports = () => {
  const toast = useToast();
  const [pendingId, setPendingId] = useState<string | null>(null);

  const handleDownload = async (item: (typeof EXPORTS)[number]) => {
    setPendingId(item.id);
    try {
      await downloadFile(item.path, item.filename);
      toast.success('Export téléchargé', item.filename);
    } catch (err) {
      const { title, description } = toUserErrorMessage(err, 'Échec du téléchargement');
      toast.error(title, description);
    } finally {
      setPendingId(null);
    }
  };

  return (
    <article className="rounded-md border border-zinc-200 bg-white p-6 flex flex-col gap-5">
      <header>
        <h2 className="text-sm font-medium text-zinc-900">Exports</h2>
        <p className="text-xs text-zinc-500 mt-0.5">Données détaillées au format Excel pour analyse complémentaire.</p>
      </header>

      <ul className="grid grid-cols-1 lg:grid-cols-3 gap-3">
        {EXPORTS.map(item => (
          <li
            key={item.id}
            className="border border-zinc-200 rounded-md p-4 flex flex-col gap-3 hover:border-zinc-300 transition-colors"
          >
            <div className="flex flex-col gap-1.5">
              <h3 className="text-sm font-medium text-zinc-900">{item.title}</h3>
              <p className="text-xs text-zinc-500 leading-relaxed">{item.description}</p>
            </div>
            <button
              type="button"
              onClick={() => handleDownload(item)}
              disabled={pendingId === item.id}
              className="inline-flex items-center justify-center gap-1.5 h-8 px-3 text-xs font-medium text-zinc-700 bg-white border border-zinc-200 rounded-md hover:bg-zinc-50 hover:border-zinc-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-100 mt-auto self-start"
            >
              <IconDownload width={12} height={12} />
              <span>{pendingId === item.id ? 'Téléchargement…' : 'Télécharger .xlsx'}</span>
            </button>
          </li>
        ))}
      </ul>
    </article>
  );
};
